"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSymbolMarginType = exports.useFuturesSymbolTradeInfo = exports.DEFAULT_LEVERAGE_V2 = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const FutureAPI_1 = require("../../../apis/FutureAPI");
const interface_1 = require("../../../interface");
const errors_1 = require("../../../interface/errors");
const factory_1 = require("./factory");
Object.defineProperty(exports, "DEFAULT_LEVERAGE_V2", { enumerable: true, get: function () { return factory_1.DEFAULT_LEVERAGE_V2; } });
const Assets_1 = require("../../../component/Assets");
const checkActiveOrder_1 = require("./../../../component/CustomOrders/checkActiveOrder");
const Trade_1 = require("./../../../component/Trade");
const isMulti_1 = require("./isMulti");
function generateError(symbolName) {
    const error = Object.assign({}, errors_1.TRADE_CHANGED_MARGIN_TYPE_FAILURE);
    error.data.symbolName = symbolName;
    return error;
}
const useInnerFuturesSymbolTradeInfo = (params, enable = true) => {
    const { symbol } = params;
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [tradeInfo, setTradeInfo] = (0, react_1.useState)(() => {
        return {
            leverage: factory_1.DEFAULT_LEVERAGE_V2 + "",
            isolated_mode: interface_1.FutureMarginType.CROSS,
            isMulti: false,
        };
    });
    const tradeInfoRef = (0, react_1.useRef)(tradeInfo);
    tradeInfoRef.current = tradeInfo;
    (0, react_1.useEffect)(() => {
        if (!symbol || !enable) {
            return;
        }
        setLoading(true);
        const sub = factory_1.SymbolTradeInfoPublishManager.getPublish(symbol).subscribe({
            next: (res) => {
                if (tradeInfoRef.current.error !== res.error ||
                    tradeInfoRef.current.isolated_mode !== res.isolated_mode ||
                    tradeInfoRef.current.leverage !== res.leverage ||
                    tradeInfoRef.current.isMulti !== res.isMulti) {
                    setTradeInfo(res);
                }
                setLoading(false);
            },
            error: (err) => {
                setLoading(false);
            },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [enable, symbol]);
    const changeMarginType = (0, react_1.useCallback)((m, symbolName) => {
        return setSymbolMarginType({ mode: m, symbol, symbolDisplay: symbolName });
    }, [symbol]);
    return (0, react_1.useMemo)(() => {
        return {
            loading,
            leverage: Number(tradeInfo.leverage),
            marginType: tradeInfo.isolated_mode,
            isMulti: tradeInfo.isMulti,
            changeMarginType,
            error: tradeInfo.error,
            symbol: symbol,
        };
    }, [changeMarginType, loading, symbol, tradeInfo.error, tradeInfo.isolated_mode, tradeInfo.leverage, tradeInfo.isMulti]);
};
const useFuturesSymbolTradeInfo = (params, enable = true) => {
    return useInnerFuturesSymbolTradeInfo(params, enable);
};
exports.useFuturesSymbolTradeInfo = useFuturesSymbolTradeInfo;
/**设置币对保证金模式 */
function setSymbolMarginType({ mode, symbol, symbolDisplay = symbol, }) {
    return factory_1.SymbolTradeInfoPublishManager.getPublish(symbol)
        .pipe(
    // 如果为初始值，则过滤掉
    (0, rxjs_1.filter)((item) => !item.isDefault), (0, operators_1.take)(1))
        .pipe((0, operators_1.mergeMap)(({ isolated_mode, isMulti }) => {
        // 切换到分仓
        if (mode === interface_1.FutureMarginType.COMPLETELY_ISOLATED) {
            return (0, isMulti_1.setMultiSymbolObserve)(symbol, true);
        }
        let ob = (0, rxjs_1.of)(null);
        // 全仓和逐仓互相切换
        if (isolated_mode !== mode) {
            ob = (0, Assets_1.getCustomAssetsObservable)().pipe((0, operators_1.take)(1), (0, operators_1.map)((assets) => {
                var _a, _b, _c;
                // 如果为联合保证金模式，不允许切换到逐仓
                if (Trade_1.CalculateUtils.isMultiAssetMarginMode((_b = (_a = assets.quoteRisks) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.assets_margin_mode)) {
                    if (mode === interface_1.FutureMarginType.ISOLATED) {
                        throw errors_1.ASSET_MARGIN_MULTI_MODE_CHANGE_MARGIN_TYPE;
                    }
                }
                const hasPosition = !!((_c = assets.positionMap.get(symbol)) === null || _c === void 0 ? void 0 : _c.length);
                // 存在仓位
                if (hasPosition) {
                    throw generateError(symbolDisplay);
                }
                return hasPosition;
            }), (0, operators_1.mergeMap)(() => (0, checkActiveOrder_1.checkActiveOrder)(trade_utils_lib_1.AccountTradeType.trader, symbol)), (0, operators_1.mergeMap)((hasActiveOrders) => {
                if (hasActiveOrders) {
                    return (0, rxjs_1.throwError)(generateError(symbolDisplay));
                }
                return (0, rxjs_1.of)(false);
            }), (0, operators_1.mergeMap)(() => (0, isMulti_1.setMultiSymbolObserve)(symbol, false)), (0, operators_1.mergeMap)(() => (0, FutureAPI_1.updateMarginType)(symbol, mode).pipe((0, operators_1.catchError)((err) => {
                if (isMulti) {
                    (0, isMulti_1.setMultiSymbolObserve)(symbol, true);
                }
                return (0, rxjs_1.throwError)(err);
            }))));
        }
        else {
            ob = (0, isMulti_1.setMultiSymbolObserve)(symbol, false);
        }
        return ob;
    }), (0, operators_1.tap)(() => {
        (0, factory_1.refreshSymbolTradeInfo)({ symbol: symbol, isolated_mode: mode, isMulti: mode === interface_1.FutureMarginType.COMPLETELY_ISOLATED });
    }), (0, operators_1.catchError)((err) => (0, rxjs_1.throwError)((0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(err))));
}
exports.setSymbolMarginType = setSymbolMarginType;
